/** Subscribe to the appearance of the Devportal embedding this window. */
export const subscribeToPortalTheme = (
  development: boolean,
  onTheme: (theme: 'light' | 'dark') => void
) => {
  if (window.parent === window) {
    return;
  }

  const origins = [
    'https://developer.visca.ai',
    ...(development ? ['https://localhost:8005', 'https://127.0.0.1:8005'] : []),
  ];
  const receive = (event: MessageEvent<unknown>) => {
    if (event.source !== window.parent || !origins.includes(event.origin)) {
      return;
    }
    const message = event.data;
    if (
      typeof message === 'object' &&
      message !== null &&
      'type' in message &&
      message.type === 'visca.portal.theme' &&
      'theme' in message &&
      (message.theme === 'light' || message.theme === 'dark')
    ) {
      onTheme(message.theme);
    }
  };
  window.addEventListener('message', receive);
  for (const origin of origins) {
    window.parent.postMessage({ type: 'visca.portal.ready' }, origin);
  }
  return () => {
    window.removeEventListener('message', receive);
  };
};
